export const routes = [{
  route: 'home#root',
  text: 'Home'
}, {
  route: 'home#how-it-works',
  text: 'How it works'
}, {
  route: 'home#faq',
  text: 'FAQ'
}, {
  route: 'login',
  text: 'Login'
}, {
  route: 'signup',
  text: 'Signup'
}];

const nonAuthRoutes = ['login', 'signup'];
export const adminAuthRoutes = [
  {
    route: 'admin-dashboard',
    text: 'Dashboard'
  }
];
export const patientAuthRoutes = [
  {
    route: 'gallery',
    text: 'Gallery'
  }
];
export const clientAuthRoutes = [
  {
    route: 'client-dashboard',
    text: 'Dashboard'
  },
  {
    route: 'clinician-dashboard',
    text: 'Patient Exams'
  }
]
export const clinicianAuthRoutes = [
  {
    route: 'clinician-dashboard',
    text: 'Dashboard'
  }
]
export const adminRoutes = [
  ...routes.filter(route => nonAuthRoutes.indexOf(route.route) === -1),
  ...adminAuthRoutes
];
export const patientRoutes = [
  ...routes.filter(route => nonAuthRoutes.indexOf(route.route) === -1),
  ...patientAuthRoutes
];
export const clientRoutes = [
  ...routes.filter(route => nonAuthRoutes.indexOf(route.route) === -1),
  ...clientAuthRoutes,
]
export const clinicianRoutes = [
  ...routes.filter(route => nonAuthRoutes.indexOf(route.route) === -1),
  ...clinicianAuthRoutes
]

export const footerRoutes = [
  ...routes.filter(route => nonAuthRoutes.indexOf(route.route) === -1),
  {
    route: 'support',
    text: 'Support'
  }
]